exports.run = (store) => {

    const Continuation = require('services/auth-management/continuation');

    if (!Continuation.captureFromLocation()) {
        Continuation.captureDestination();
    }

    const initializers = [
        require('./app-context'),
        require('./connectivity'),
        require('./auth'),
        require('./fetch-data'),
        require('./notifications').initialize,
        require('./analytics'),
        require('./cordova'),
        require('./foreground'),
        require('./google-places'),
        require('./watch-history'),
        require('./signup'),
        require('./persist-filters')
    ];

    initializers.forEach((init) => init(store));
};
